module.exports = __webpack_public_path__ + "img/stat_05_icon.bba4fa1f.png";